const removeExcessMozillaAndVersion = /^mozilla\/\d\.\d\W/;
const browserPattern = /(\w+)\/(\d+\.\d+(?:\.\d+)?(?:\.\d+)?)/g;
const engineAndVersionPattern = /^(ver|cri|gec)/;
const brandList = ['chrome', 'opera', 'safari', 'edge', 'firefox'];
const unknown = 'Unknown';
const empty = '';

// userAgentData should be used for Chromium based browsers when userAgent is deprecated by Chrome
// https://www.chromium.org/updates/ua-reduction/
// @ts-ignore
const { userAgentData } = window.navigator;
const { userAgent } = window.navigator;

const detectBrowserInfo = () => {
    if (userAgent) {
        const ua = userAgent
            .toLowerCase()
            .replace(removeExcessMozillaAndVersion, empty);

        // Extract browser and version information.
        const browserTest = ua.match(browserPattern);
        const versionRegex = /version\/(\d+(\.\d+)*)/;

        const safariVersion = ua.match(versionRegex);
        const saVesion = Array.isArray(safariVersion) ? safariVersion[1] : null;
        const browserOffset =
            browserTest &&
            (browserTest.length > 2 &&
            !engineAndVersionPattern.test(browserTest[1]) &&
            !browserTest[browserTest.length - 1].includes('opr') &&
            !browserTest[browserTest.length - 1].includes('edg')
                ? 1
                : 0);
        const browserResult =
            browserTest &&
            browserTest[browserTest.length - 1 - (browserOffset || 0)].split(
                '/',
            );
        let browser = browserResult && browserResult[0];
        const version = saVesion || (browserResult && browserResult[1]);

        if (browser === 'opr') {
            browser = 'opera';
        } else if (browser === 'edg') {
            browser = 'edge';
        }

        return {
            browser: browser
                ? `${browser[0].toUpperCase()}${browser.slice(1).toLowerCase()}`
                : browser,
            version,
        };
    }

    if (userAgentData) {
        let platformData;

        // eslint-disable-next-line no-restricted-syntax
        for (const agentBrand of userAgentData.brands) {
            const agentBrandEntry = agentBrand.brand.toLowerCase();
            const foundBrand = brandList.find((brand) => {
                //eslint-disable-line
                if (agentBrandEntry.includes(brand)) {
                    return brand;
                }
            });

            if (foundBrand) {
                platformData = {
                    browser: `${foundBrand[0].toUpperCase()}${foundBrand
                        .slice(1)
                        .toLowerCase()}`,
                    version: agentBrand.version,
                };

                break;
            }
        }

        const brandVersionData = platformData || {
            browser: unknown,
            version: unknown,
        };

        return brandVersionData;
    }

    return {
        browser: unknown,
        version: unknown,
    };
};

export default detectBrowserInfo;
